module.exports = new __parcel__URL__("InlineEmbedIcon.eb3ad338.svg").toString();